import script from "./Clock.vue?vue&type=script&setup=true&lang=js"
export * from "./Clock.vue?vue&type=script&setup=true&lang=js"

import "./Clock.vue?vue&type=style&index=0&id=2af9c84a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2af9c84a"]])

export default __exports__